/* Native scroll rails and opt-in films. No player library or autoplay. */
if (!customElements.get('vv-editorial-rail')) {
  customElements.define('vv-editorial-rail', class extends HTMLElement {
    connectedCallback() {
      this.rail = this.querySelector('[data-media-rail]');
      this.items = [...this.querySelectorAll('[data-media-item]')];
      this.navigation = this.querySelector('[data-media-navigation]');
      if (!this.rail || !this.items.length || !this.navigation) return;
      this.abort?.abort(); this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.previous = this.querySelector('[data-media-previous]');
      this.next = this.querySelector('[data-media-next]');
      this.count = this.querySelector('[data-media-count]');
      this.previous.addEventListener('click', () => this.move(-1), options);
      this.next.addEventListener('click', () => this.move(1), options);
      this.rail.addEventListener('scroll', () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.update());
      }, { ...options, passive: true });
      this.rail.addEventListener('keydown', event => {
        if (event.target !== this.rail || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        if (event.key === 'Home') this.go(0);
        else if (event.key === 'End') this.go(this.items.length - 1);
        else this.move(event.key === 'ArrowRight' ? 1 : -1);
      }, options);
      document.addEventListener('shopify:block:select', event => {
        const index = this.items.findIndex(item => item.dataset.mediaItem === event.detail?.blockId);
        if (index >= 0) this.go(index, 'auto');
      }, options);
      if ('ResizeObserver' in window) {
        this.resize = new ResizeObserver(() => this.update()); this.resize.observe(this.rail);
      } else window.addEventListener('resize', () => this.update(), options);
      this.update();
    }
    update() {
      const rect = this.rail.getBoundingClientRect();
      this.current = this.items.reduce((best, item, index) => Math.abs(item.getBoundingClientRect().left - rect.left) < Math.abs(this.items[best].getBoundingClientRect().left - rect.left) ? index : best, 0);
      const overflowing = this.rail.scrollWidth > this.rail.clientWidth + 2;
      this.navigation.hidden = !overflowing;
      this.rail.tabIndex = overflowing ? 0 : -1;
      this.previous.disabled = this.items[0].getBoundingClientRect().left >= rect.left - 2;
      this.next.disabled = this.items.at(-1).getBoundingClientRect().right <= rect.right + 2;
      const text = `${this.current + 1} / ${this.items.length}`;
      if (this.count.textContent !== text) this.count.textContent = text;
    }
    move(direction) { this.go(this.current + direction); }
    go(index, behavior) {
      const target = this.items[Math.max(0, Math.min(index, this.items.length - 1))];
      const left = this.rail.scrollLeft + target.getBoundingClientRect().left - this.rail.getBoundingClientRect().left;
      this.rail.scrollTo({ left, behavior: behavior || (window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth') });
    }
    disconnectedCallback() {
      this.abort?.abort(); this.resize?.disconnect(); cancelAnimationFrame(this.frame);
    }
  });
}

if (!customElements.get('vv-brand-film')) {
  customElements.define('vv-brand-film', class extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      this.button = this.querySelector('[data-film-start]');
      this.message = this.querySelector('[data-film-message]');
      if (!this.video || !this.button) return;
      this.abort?.abort(); this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.visible = true;
      this.video.controls = false; this.video.muted = true;
      this.button.hidden = false;
      this.button.addEventListener('click', () => this.start(), options);
      this.video.addEventListener('play', () => {
        if (this.selected === false || !this.visible || document.hidden || (this.pending && this.interrupted)) { this.video.pause(); return; }
        this.interrupted = false;
        this.button.hidden = true; this.video.controls = true;
        document.dispatchEvent(new CustomEvent('vv:film-play', { detail: { player: this } }));
      }, options);
      this.video.addEventListener('error', () => this.fail(), options);
      document.addEventListener('vv:film-play', event => { if (event.detail.player !== this) { this.interrupted = true; this.video.pause(); } }, options);
      document.addEventListener('visibilitychange', () => { if (document.hidden) this.video.pause(); }, options);
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          this.visible = entries.some(entry => entry.isIntersecting && entry.intersectionRatio >= .2);
          if (!this.visible) this.video.pause();
        }, { threshold: [0, .2] });
        this.observer.observe(this);
      }
    }
    async start() {
      if (this.pending || this.selected === false) return;
      this.pending = true; this.button.disabled = true; this.message.textContent = '';
      this.interrupted = false;
      document.dispatchEvent(new CustomEvent('vv:film-play', { detail: { player: this } }));
      this.button.setAttribute('aria-busy', 'true');
      this.querySelectorAll('source[data-src]').forEach(source => {
        source.src = source.dataset.src; source.removeAttribute('data-src');
      });
      this.video.load();
      this.video.controls = true;
      try {
        await this.video.play();
        if (this.selected === false || !this.visible || document.hidden || !this.isConnected || this.interrupted) this.video.pause();
        else this.button.hidden = true;
      } catch (_) { if (this.selected !== false && !this.interrupted && this.visible && !document.hidden && this.isConnected) this.fail(); }
      finally { this.pending = false; this.button.disabled = false; this.button.removeAttribute('aria-busy'); }
    }
    resetPlayback() {
      this.interrupted = true;
      if (!this.video) return;
      this.video.pause();
      /* load() restores the poster; preload=none prevents an eager download. */
      this.video.load();
      this.video.controls = false;
      this.button.hidden = false;
      this.message.textContent = '';
    }
    fail() {
      if (this.selected === false || this.interrupted) return;
      this.button.hidden = false;
      this.video.controls = true;
      this.message.textContent = 'No se pudo reproducir el video. Inténtalo de nuevo.';
    }
    disconnectedCallback() {
      this.abort?.abort(); this.observer?.disconnect(); this.video?.pause();
    }
  });
}
